<template>
  <div class="steps3-content">
    <div>
      <div>
        <span>输入新密码：</span>
        <input type="password" v-model="password1" />
      </div>
      <div>
        <span>再次输入密码：</span>
        <input type="password" v-model="password2" />
      </div>
      <div v-if="!isSame">
        <img
          src="../../../assets/image/password-no-icon.png"
          alt="设置新密码"
        />
        <span>两次输入不一致</span>
      </div>
      <div @click="handleSubmit">确定</div>
    </div>

    <div></div>
    <div>
      <div>
        <span></span>
        <span>操作说明</span>
      </div>
      <div>1、请设置不低于6位的密码，可输入数字、字母做密码。</div>
      <div>2、两次输入要一致。</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Steps3',
  props: ['toNext'],
  data() {
    return {
      password1: '',
      password2: '',
      isSame: true
    }
  },
  watch: {
    password1: function () {
      if (!this.isSame) this.isSame = true
      if (this.password2) this.password2 = ''
    },
    password2: function () {
      if (!this.isSame) this.isSame = true
    }
  },
  methods: {
    handleSubmit() {
      const { password1, password2 } = this
      if (password1 !== password2) {
        this.isSame = false
        return
      }
      this.toNext()
    }
  }
}
</script>
<style lang="scss" scoped>
.steps3-content {
  display: flex;
  justify-content: center;
  align-items: center;
  > div:first-child {
    > div {
      > span {
        display: inline-block;
      }
      > span:first-child {
        width: 120px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        text-align: right;
        margin-right: 20px;
      }
      > input {
        outline: none;
        border: none;
        background: none;
        width: 183px;
        height: 30px;
        border: 1px solid #0345ad;
      }
    }
    > div:first-child {
      margin-bottom: 23px;
    }
    > div:nth-child(2) {
      margin-bottom: 10px;
    }
    > div:nth-child(3) {
      text-align: right;
      > img {
        vertical-align: middle;
        margin-right: 5px;
      }
    }
    > div:last-child {
      width: 152px;
      height: 38px;
      background: linear-gradient(90deg, #105abf 0%, #486dee 100%);
      border-radius: 19px;
      line-height: 38px;
      text-align: center;
      cursor: pointer;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      margin: 43px auto 0;
    }
  }
  > div:nth-child(2) {
    width: 0;
    height: 337px;
    border-left: 2px dashed #c6c6c6;
    margin: 0 124px 0 174px;
  }
  > div:last-child {
    > div:first-child {
      margin-bottom: 32px;
      > span:first-child {
        display: inline-block;
        width: 6px;
        height: 6px;
        background: #d00d0d;
        border-radius: 50%;
        margin-right: 6px;
        vertical-align: center;
      }
    }
    > div:not(div:first-child) {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-bottom: 30px;
    }
  }
}
</style>
